import { Filters } from "./components/filters/filters";
import { Preview } from "./components/preview/preview";
import { ProductList } from "./components/productList/productList";
import { Base } from "./products.base";

export const Products = Object.assign(Base, {
    ProductList,
    Filters,
    Preview
});
